import React from 'react'

const Loading = ({ ...props }) => <div {...props}>Loading...</div>

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading.js